<template>
  <v-dialog v-model="value" width="1000" @keydown.esc="dismiss()" persistent>
    <v-card>
      <v-card-title
        class="py-2 d-flex justify-space-between align-center blue white--text"
      >
        {{ $t('invoice.transfer_paper') }}
      </v-card-title>

      <v-card-text class="px-0 py-0" v-show="!isLoading">
        <iframe
          src=""
          width="100%"
          height="500px"
          frameborder="0"
          name="printIframe"
          id="printIframe"
        ></iframe>
      </v-card-text>

      <v-card-text class="px-0 py-0">
        <v-card
          class="justify-center py-10 d-flex"
          v-if="isLoading"
          elevation="0"
        >
          <v-progress-circular
            indeterminate
            size="64"
            color="green"
          ></v-progress-circular>
        </v-card>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" @click="dismiss()"> {{ $t('close') }} </v-btn>
        <v-btn color="info" :disabled="isLoading" @click="print()">
          <v-icon dark class="me-2"> mdi-printer </v-icon> {{ $t('print') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    checkoutId: String,
  },
  data() {
    return {
      isLoading: false,
      PRINT_SERVER_URL:
        process.env.VUE_APP_PRINT_SERVER_URL ||
        "https://market-print-dev-bq4s7k7bea-as.a.run.app",
    };
  },
  watch: {
    value(newv) {
      if (newv) this.initData();
    },
  },
  methods: {
    async initData() {
      if (this.checkoutId) {
        this.isLoading = true;
        setTimeout(() => {
          let sessionToken = "";
          if (localStorage.getItem("sessionToken")) {
            sessionToken = localStorage.getItem("sessionToken");
          }

          let form = document.createElement("form");
          let body = {
            id: this.checkoutId,
            sessionToken,
          };

          form._submit_function_ = form.submit;
          form.setAttribute("method", "post");
          form.setAttribute("action", this.PRINT_SERVER_URL + "/checkout");
          form.setAttribute("target", "printIframe");
          for (var key in body) {
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", body[key]);

            form.appendChild(hiddenField);
          }
          document.body.appendChild(form);
          form._submit_function_(); //Call the renamed function.
          this.isLoading = false;
        }, 500);
      }
    },
    print() {
      let PDF = document.getElementById("printIframe");
      PDF.focus();
      try {
        PDF.contentWindow.print();
      } catch (ex) {
        PDF.contentWindow.postMessage("print", "*");
      }
    },
    dismiss() {
      document.getElementById("printIframe").setAttribute("src", "");
      this.$emit("input", false);
    },
  },
};
</script>

<style>
</style>